export default __webpack_public_path__ + "static/media/fishBoom.4a353134.png";